import React from 'react'
import { graphql } from 'gatsby'
import SwiperCore, { Pagination, Navigation } from 'swiper'
import { Swiper, SwiperSlide } from 'swiper/react'
import style from './carousel.mod.scss'
import { Button } from '@components'

SwiperCore.use([Navigation, Pagination])

const Carousel = ({
  children,
  id,
  heading,
  config,
  scaleSlides,
  link,
  slim = false,
  emphasiseActive = false,
  placeNavigation
}) => {
  const modifiers = []

  slim && modifiers.push(`${style.carousel}--slim`)
  scaleSlides && modifiers.push(`${style.carousel}--scale`)
  emphasiseActive && modifiers.push(`${style.carousel}--emphasise-active`)
  placeNavigation &&
    modifiers.push(
      `${style.carousel}--place-navigation-${placeNavigation
        .trim()
        .toLowerCase()
        .replace(/ /gi, '-')}`
    )

  const slides = children.map((slide, i) => {
    return <SwiperSlide key={`${id}-slide-${i}`}>{slide}</SwiperSlide>
  })

  return (
    <div className={[style.carousel, ...modifiers].join(' ')}>
      <Swiper
        spaceBetween={5}
        slidesPerView={2}
        pagination={{ clickable: true }}
        centeredSlides
        speed={800}
        grabCursor
        initialSlide={1}
        {...config}
      >
        {slides}
      </Swiper>
      {(link?.link?.path || link?.url) && (
        <div className={style.carousel__link}>
          <Button to={link?.link?.path || link?.url}>{link.displayText}</Button>
        </div>
      )}
    </div>
  )
}

export default Carousel

export const query = graphql`
  fragment CardsCarousel on DatoCmsCardsCarousel {
    id
    background
    backgroundStyle
    padding
    model {
      apiKey
    }
    leadNode {
      childMarkdownRemark {
        html
      }
    }
    heading
    link {
      ...Link
    }
    cards {
      ...CardSlide
    }
  }

  fragment PostsCarousel on DatoCmsPostsCarousel {
    id
    background
    backgroundStyle
    padding
    model {
      apiKey
    }
    leadNode {
      childMarkdownRemark {
        html
      }
    }
    categories {
      id
      slug
      title
    }
    backgroundStyle
    heading
    link {
      ...Link
    }
  }

  fragment PeopleCarousel on DatoCmsPeopleCarousel {
    id
    background
    backgroundStyle
    padding
    model {
      apiKey
    }
    leadNode {
      childMarkdownRemark {
        html
      }
    }
    people {
      ...PersonCard
    }
    backgroundStyle
    heading
    link {
      ...Link
    }
  }

  fragment ReviewsCarousel on DatoCmsReviewsCarousel {
    id
    model {
      apiKey
    }
    background
    backgroundStyle
    padding
    heading
    link {
      ...Link
    }
    reviews {
      id
      internalTitle
      name
      rating
      date(fromNow: true)
      text
      image {
        fluid(maxWidth: 60, imgixParams: { fit: "crop", w: "60", h: "60" }) {
          ...GatsbyDatoCmsFluid
        }
      }
    }
  }
`
